import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Chip from '@material-ui/core/Chip'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import EditIcon from '@material-ui/icons/Edit'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { contentVectorizationActions, messageActions } from '../../actions'
import { processHtmlWithTableBorders } from '../../utils/htmlUtils'
import { getApiErrorMessage } from '../../utils'
import LocalHtmlEditorModal from '../../components/LocalHtmlEditorModal'
import { ContentHtml } from 'informed-shared/components/es/Content'

// Tipos de conteúdo conforme definido na API
export const TIPOS_CONTEUDO = [
  'artigo',
  'aula',
  'capitulo',
  'diretriz',
  'medicamento',
  'figura',
  'fluxograma',
  'tabela',
  'podcast',
  'webinar',
  'consulta_rapida_e_recomendacoes',
  'diagnostico_e_tratamento',
  'habilidades_clinicas',
]

export const TIPOS_CONTEUDO_LABELS = {
  artigo: 'Artigo',
  aula: 'Aula',
  capitulo: 'Capítulo',
  diretriz: 'Diretriz',
  medicamento: 'Ficha de medicamento',
  figura: 'Figura',
  fluxograma: 'Fluxograma',
  tabela: 'Tabela',
  podcast: 'Podcast',
  webinar: 'Webinar',
  consulta_rapida_e_recomendacoes: 'Consulta rápida e recomendações',
  diagnostico_e_tratamento: 'Diagnóstico e tratamento',
  habilidades_clinicas: 'Habilidades Clínicas',
}

const styles = () => ({
  dialogContent: {
    position: 'relative',
    minHeight: '400px',
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.85)',
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  formControl: {
    margin: '14px 0',
  },
  helperText: {
    fontSize: '0.75rem',
    marginTop: '4px',
    color: 'rgba(0, 0, 0, 0.54)',
  },
  htmlPreview: {
    border: '1px solid #e0e0e0',
    borderRadius: '2px',
    padding: '16px',
    maxHeight: '250px',
    minHeight: '180px',
    overflow: 'auto',
    backgroundColor: '#fff',
    marginTop: '8px',
    '& table': {
      borderCollapse: 'collapse',
      width: '100%',
      margin: '8px 0',
    },
    '& td, & th': {
      border: '1px solid #ccc',
      padding: '4px 8px',
      verticalAlign: 'top',
    },
    '& th, & .gravata, & [class*="gravata"], & .thead, & .table-header': {
      backgroundColor: '#e8eaf6 !important',
      fontWeight: 'bold',
    },
    '& img': {
      maxWidth: '100%',
      height: 'auto',
    },
  },
  htmlPreviewLabel: {
    marginTop: '8px',
    marginBottom: '4px',
    fontWeight: 500,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
})

class AddModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      autoresInput: '',
      htmlEditorOpen: false,
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const { conteudo, setConteudoFormTouched, addConteudo, changeMessage, onClose } = this.props

    if (!conteudo.tipo || !conteudo.titulo || !conteudo.conteudoHtml) {
      setConteudoFormTouched()
      return
    }

    const payload = {
      tipo: String(conteudo.tipo || '').trim(),
      titulo: String(conteudo.titulo || '').trim(),
      conteudoHtml: conteudo.conteudoHtml,
    }

    if (conteudo.content_id) payload.content_id = String(conteudo.content_id).trim()
    if (conteudo.autores && conteudo.autores.length > 0) payload.autores = conteudo.autores
    if (conteudo.ano) payload.ano = parseInt(conteudo.ano, 10)
    if (conteudo.especialidade) payload.especialidade = conteudo.especialidade
    if (conteudo.isbn) payload.isbn = conteudo.isbn
    if (conteudo.idVetor) payload.idVetor = conteudo.idVetor

    addConteudo(payload)
      .then(() => {
        changeMessage({ message: 'Conteúdo enviado para vetorização com sucesso.' })
        onClose()
      })
      .catch((err) => {
        changeMessage({
          message: getApiErrorMessage(err, 'Erro ao enviar conteúdo.'),
          type: 'error',
        })
      })
  }

  handleAddAutor = () => {
    const { handleChangeConteudo, conteudo } = this.props
    const { autoresInput } = this.state
    if (autoresInput.trim()) {
      const novos = autoresInput
        .split(/[,;]+/)
        .map((n) => n.trim())
        .filter((n) => n.length > 0)
      handleChangeConteudo({ ...conteudo, autores: [...(conteudo.autores || []), ...novos] })
      this.setState({ autoresInput: '' })
    }
  }

  handleRemoveAutor = (index) => {
    const { handleChangeConteudo, conteudo } = this.props
    handleChangeConteudo({
      ...conteudo,
      autores: (conteudo.autores || []).filter((_, i) => i !== index),
    })
  }

  handleHtmlChange = (rawValue) => {
    const { handleChangeConteudo, conteudo } = this.props
    handleChangeConteudo({ ...conteudo, conteudoHtml: processHtmlWithTableBorders(rawValue) })
  }

  handleApplyHtml = (newHtml) => {
    const { handleChangeConteudo, conteudo } = this.props
    handleChangeConteudo({ ...conteudo, conteudoHtml: newHtml })
    this.setState({ htmlEditorOpen: false })
  }

  render() {
    const {
      fullScreen,
      open,
      onClose,
      classes,
      conteudo,
      handleChangeConteudo,
      loadingConteudo,
      conteudoFormTouched,
    } = this.props

    const { autoresInput, htmlEditorOpen } = this.state

    const isTipoError = conteudoFormTouched && !conteudo.tipo
    const isTituloError = conteudoFormTouched && !conteudo.titulo
    const isHtmlError = conteudoFormTouched && !conteudo.conteudoHtml
    const isRevectorization = !!conteudo.content_id

    return (
      <Fragment>
        <Dialog
          modalId="vetorizacao-conteudos-novo-conteudo"
          modalParams={{ tipo: conteudo.tipo, idVetor: conteudo.idVetor }}
          fullScreen={fullScreen}
          fullWidth
          maxWidth="lg"
          open={open}
          onClose={!loadingConteudo ? onClose : undefined}
        >
          <DialogTitle id="vetorizacao-conteudos-novo-conteudo-title">
            {isRevectorization
              ? 'Vetorização de conteúdos — Editar para vetorizar novamente'
              : 'Vetorização de conteúdos — Novo conteúdo'}
          </DialogTitle>

          <DialogContent className={classes.dialogContent}>
            {loadingConteudo && (
              <div className={classes.loadingOverlay}>
                <CircularProgress size={50} />
                <Typography variant="subtitle1" style={{ marginTop: 16, fontWeight: 500 }}>
                  Enviando conteúdo...
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  Por favor, aguarde.
                </Typography>
              </div>
            )}

            <form
              id="add-conteudo-form"
              noValidate
              onSubmit={this.handleSubmit}
              style={{ opacity: loadingConteudo ? 0.3 : 1 }}
            >
              {/* Tipo */}
              <FormControl className={classes.formControl} fullWidth error={isTipoError}>
                <InputLabel htmlFor="field-tipo-cont">Tipo *</InputLabel>
                <Select
                  value={conteudo.tipo || ''}
                  onChange={(e) => handleChangeConteudo({ ...conteudo, tipo: e.target.value })}
                  inputProps={{ id: 'field-tipo-cont' }}
                  disabled={loadingConteudo}
                >
                  {TIPOS_CONTEUDO.map((tipo) => (
                    <MenuItem key={tipo} value={tipo}>
                      {TIPOS_CONTEUDO_LABELS[tipo] || tipo}
                    </MenuItem>
                  ))}
                </Select>
                {isTipoError && (
                  <Typography color="error" variant="caption">
                    Tipo é obrigatório.
                  </Typography>
                )}
              </FormControl>

              {/* Título */}
              <FormControl className={classes.formControl} fullWidth error={isTituloError}>
                <InputLabel htmlFor="field-titulo-cont">Título *</InputLabel>
                <Input
                  id="field-titulo-cont"
                  value={conteudo.titulo || ''}
                  onChange={(e) => handleChangeConteudo({ ...conteudo, titulo: e.target.value })}
                  disabled={loadingConteudo}
                  autoFocus
                />
                {isTituloError && (
                  <Typography color="error" variant="caption">
                    Título é obrigatório.
                  </Typography>
                )}
              </FormControl>

              {/* Content ID */}
              <FormControl className={classes.formControl} fullWidth>
                <InputLabel htmlFor="field-content-id-cont">ID do Conteúdo (opcional)</InputLabel>
                <Input
                  id="field-content-id-cont"
                  value={conteudo.content_id || ''}
                  onChange={(e) => handleChangeConteudo({ ...conteudo, content_id: e.target.value })}
                  disabled={loadingConteudo}
                />
                <FormHelperText className={classes.helperText}>
                  Deixe em branco para gerar automaticamente
                </FormHelperText>
              </FormControl>

              {/* Autores */}
              <FormControl className={classes.formControl} fullWidth>
                <InputLabel htmlFor="field-autores-cont">Autores (opcional)</InputLabel>
                <Input
                  id="field-autores-cont"
                  value={autoresInput}
                  onChange={(e) => this.setState({ autoresInput: e.target.value })}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault()
                      this.handleAddAutor()
                    }
                  }}
                  disabled={loadingConteudo}
                  placeholder="Digite os nomes separados por vírgula e pressione Enter"
                />
                <FormHelperText className={classes.helperText}>
                  Pressione Enter para adicionar
                </FormHelperText>
                {(conteudo.autores || []).length > 0 && (
                  <div style={{ marginTop: '8px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {conteudo.autores.map((autor, i) => (
                      <Chip
                        key={i}
                        label={autor}
                        onDelete={() => this.handleRemoveAutor(i)}
                        color="primary"
                        variant="outlined"
                      />
                    ))}
                  </div>
                )}
              </FormControl>

              {/* Ano */}
              <FormControl className={classes.formControl} fullWidth>
                <InputLabel htmlFor="field-ano-cont">Ano de Publicação (opcional)</InputLabel>
                <Input
                  id="field-ano-cont"
                  type="number"
                  value={conteudo.ano || ''}
                  onChange={(e) =>
                    handleChangeConteudo({
                      ...conteudo,
                      ano: e.target.value ? parseInt(e.target.value, 10) : null,
                    })
                  }
                  disabled={loadingConteudo}
                  inputProps={{ min: 1900, max: new Date().getFullYear() + 1 }}
                />
              </FormControl>

              {/* Especialidade */}
              <FormControl className={classes.formControl} fullWidth>
                <InputLabel htmlFor="field-esp-cont">Especialidade (opcional)</InputLabel>
                <Input
                  id="field-esp-cont"
                  value={conteudo.especialidade || ''}
                  onChange={(e) =>
                    handleChangeConteudo({ ...conteudo, especialidade: e.target.value })
                  }
                  disabled={loadingConteudo}
                  placeholder="Ex: Cardiologia, Direito Civil"
                />
              </FormControl>

              {/* ISBN */}
              <FormControl className={classes.formControl} fullWidth>
                <InputLabel htmlFor="field-isbn-cont">ISBN (opcional)</InputLabel>
                <Input
                  id="field-isbn-cont"
                  value={conteudo.isbn || ''}
                  onChange={(e) =>
                    handleChangeConteudo({ ...conteudo, isbn: e.target.value || null })
                  }
                  disabled={loadingConteudo}
                />
              </FormControl>

              {/* Conteúdo HTML */}
              <FormControl className={classes.formControl} fullWidth error={isHtmlError}>
                <InputLabel htmlFor="field-html-cont" shrink>
                  Conteúdo HTML *
                </InputLabel>
                <Input
                  id="field-html-cont"
                  multiline
                  rows={6}
                  value={conteudo.conteudoHtml || ''}
                  onChange={(e) => this.handleHtmlChange(e.target.value)}
                  disabled={loadingConteudo}
                  placeholder="<p>Texto completo do conteúdo...</p>"
                  style={{ marginTop: '16px' }}
                />
                <FormHelperText className={classes.helperText}>
                  Conteúdo em formato HTML que será vetorizado
                </FormHelperText>
                {isHtmlError && (
                  <Typography color="error" variant="caption">
                    Conteúdo HTML é obrigatório.
                  </Typography>
                )}
              </FormControl>

              {/* Preview HTML */}
              <div className={classes.htmlPreviewLabel}>
                <Typography variant="caption" color="textSecondary">
                  Prévia CMS do conteúdo
                </Typography>
                <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  disabled={loadingConteudo}
                  onClick={() => this.setState({ htmlEditorOpen: true })}
                >
                  <EditIcon style={{ fontSize: 15, marginRight: 4 }} />
                  Editar Conteúdo HTML
                </Button>
              </div>
              <div className={'ContentPreview ContentPreview-min-600 ContentPreview-hide-unknown-markers InformedContentStyle ' + classes.htmlPreview}>
                {conteudo.conteudoHtml ? (
                  <ContentHtml content={conteudo} contentPreview={conteudo.conteudoHtml} />
                ) : (
                  <em style={{ color: '#aaa' }}>Sem conteúdo HTML</em>
                )}
              </div>

              {/* idVetor */}
              <FormControl className={classes.formControl} fullWidth>
                <InputLabel htmlFor="field-id-vetor-cont">ID Vetor (opcional)</InputLabel>
                <Input
                  id="field-id-vetor-cont"
                  value={conteudo.idVetor || ''}
                  onChange={(e) =>
                    handleChangeConteudo({ ...conteudo, idVetor: e.target.value || null })
                  }
                  disabled={loadingConteudo}
                />
                <FormHelperText className={classes.helperText}>
                  Identificador de vetor existente (opcional)
                </FormHelperText>
              </FormControl>
            </form>
          </DialogContent>

          <DialogActions>
            <Button onClick={onClose} color="default" disabled={loadingConteudo}>
              Cancelar
            </Button>
            <Button
              type="submit"
              form="add-conteudo-form"
              variant="contained"
              color="primary"
              disabled={loadingConteudo}
            >
              {loadingConteudo
                ? 'Enviando...'
                : isRevectorization
                  ? 'Enviar novamente ao Sniper'
                  : 'Enviar para Vetorização'}
            </Button>
          </DialogActions>
        </Dialog>

        <LocalHtmlEditorModal
          modalId="vetorizacao-conteudos-editor-html"
          modalTitle="Vetorização de conteúdos — Editor HTML"
          modalParams={{ tipo: conteudo.tipo, idVetor: conteudo.idVetor }}
          open={htmlEditorOpen}
          onClose={() => this.setState({ htmlEditorOpen: false })}
          onApply={this.handleApplyHtml}
          initialContent={conteudo.conteudoHtml || ''}
        />
      </Fragment>
    )
  }
}

AddModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  conteudo: PropTypes.object.isRequired,
  handleChangeConteudo: PropTypes.func.isRequired,
  loadingConteudo: PropTypes.bool.isRequired,
  conteudoFormTouched: PropTypes.bool.isRequired,
  addConteudo: PropTypes.func.isRequired,
  setConteudoFormTouched: PropTypes.func.isRequired,
  changeMessage: PropTypes.func.isRequired,
}

const mapStateToProps = ({ contentVectorization, auth }) => ({
  conteudo: contentVectorization.conteudo,
  loadingConteudo: contentVectorization.loadingConteudo,
  conteudoFormTouched: contentVectorization.conteudoFormTouched,
  token: auth.token,
})

const mapDispatchToProps = {
  handleChangeConteudo: contentVectorizationActions.handleChangeConteudo,
  addConteudo: contentVectorizationActions.addConteudo,
  setConteudoFormTouched: contentVectorizationActions.setConteudoFormTouched,
  changeMessage: messageActions.changeMessage,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withMobileDialog()(withStyles(styles)(AddModal)))



// WEBPACK FOOTER //
// ./src/containers/ContentVectorization/AddModal.js